// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md style="margin-bottom:100px;">
    <v-row wrap>
      <v-col col="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'image-categories'"
        editRoute="categoryEdit"
        :headers="headers"
        name="Categories"
        permissions="image-categories"
        search
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ItemList from 'vue-common/components/ItemList.vue'
import {ENDPOINT} from '@/shared/constants'
import {mapActions} from 'vuex'

export default {
  components: {
    ItemList
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Description',
          value: 'description',
          sortable: true
        },
        {
          text: 'Hidden',
          value: 'hidden',
          type: 'checkbox'
        }
      ]
    }
  },

  methods: {
    ...mapActions([
      'fetchCategories'
    ])
  },

  destroyed () {
    // fetch updated categories after edits
    this.fetchCategories()
  }
}
</script>



// WEBPACK FOOTER //
// Categories.vue?5b415d4a